// src/AudioSpectrum/effects/waterfall.js

export const drawWaterfall = (ctx, frequencyData, width, height, historyRef) => {
  historyRef.current.push([...frequencyData.slice(0, width / 2)]);
  
  if (historyRef.current.length > height / 2) {
    historyRef.current.shift();
  }
  
  ctx.clearRect(0, 0, width, height);
  
  // 배경에서 앞으로 그리기
  for (let y = 0; y < historyRef.current.length; y++) {
    const spectrum = historyRef.current[y];
    const alpha = y / historyRef.current.length;
    
    for (let x = 0; x < spectrum.length; x++) {
      const value = spectrum[x];
      if (value > 50) { // 임계값 이상만 그리기
        const barHeight = (value / 255) * 20;
        const hue = (x / spectrum.length) * 360;
        
        ctx.fillStyle = `hsla(${hue}, 100%, 50%, ${alpha})`;
        ctx.fillRect(
          x * 4,
          height - y * 2 - barHeight,
          3,
          barHeight
        );
      }
    }
  }
};